<template>
  <div>
    <br/>
    <b-img
      center
     style="margin-top: 20"
      src="corporacion.svg"
      width="160">
    </b-img>
    <br/>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
